
import {
    TouchableOpacity,
    View
} from "react-native";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";
import {
    useDebouncedDimensions
} from "../../utils";
import {
    type BottomTabBarProps
} from "@react-navigation/bottom-tabs";

const TabBar: React.FC<BottomTabBarProps> = ({
    descriptors,
    navigation,
    state
}) => {
    const {
        radiuses,
        spaces,
        colors
    } = NCoreUIKitTheme.useContext();

    const {
        windowWidth
    } = useDebouncedDimensions();

    return <View
        style={[
            stylesheet.container,
            {
                width: windowWidth,
                bottom: spaces.spacingXl
            }
        ]}
    >
        <View
            style={[
                stylesheet.tabBar,
                {
                    width: windowWidth * 0.88,
                    backgroundColor: colors.content.container.default,
                    paddingHorizontal: spaces.spacingMd,
                    paddingVertical: spaces.spacingMd,
                    borderRadius: radiuses.full
                }
            ]}
        >
            {state.routes.map((route, index) => {
                const options = descriptors[route.key]?.options;
                const isFocused = state.index === index;
                const label = options?.tabBarLabel !== undefined ? options.tabBarLabel : route.name;

                const onPress = () => {
                    const event = navigation.emit({
                        type: "tabPress",
                        target: route.key,
                        canPreventDefault: true
                    });
                    if (!isFocused && !event.defaultPrevented) {
                        navigation.navigate(route.name);
                    }
                };

                return <TouchableOpacity
                    key={route.key}
                    onPress={onPress}
                    activeOpacity={0.8}
                    style={[
                        [
                            stylesheet.tabItem,
                            {
                                paddingVertical: spaces.spacingMd,
                                paddingHorizontal: spaces.spacingMd,
                                borderRadius: radiuses.full
                            }
                        ],
                        isFocused ? [
                            stylesheet.activeTabItem,
                            {
                                backgroundColor: colors.content.container.mid,
                                paddingHorizontal: spaces.spacingLg
                            }
                        ] : null
                    ]}
                >
                    {options?.tabBarIcon && (
                        <View
                            style={[
                                stylesheet.iconContainer,
                                {
                                    marginRight: isFocused ? spaces.spacingMd : 0
                                }
                            ]}
                        >
                            {options?.tabBarIcon({
                                color: isFocused ? colors.content.icon.high : colors.content.icon.disabled,
                                focused: isFocused,
                                size: 24
                            })}
                        </View>)}
                    {isFocused &&
                    <Text
                        variant="titleMediumSize"
                        color="high"
                    >
                        {typeof label === "string" ? label : route.name}
                    </Text>
                    }
                </TouchableOpacity>;
            })}
        </View>
    </View>;
};
export default TabBar;
